import { TbLink } from '@website-builder/model/domain/link/tb-link';
import { BlendMode } from '@website-builder/model/style/blend-mode';
import { makeEntityId } from '@website-builder/util/make-widget-id.utility';
import { EntityIdPrefix } from '@website-builder/model/domain/entity-id-prefix.enum';

export class SlideshowElement {
  id = makeEntityId(EntityIdPrefix.WIDGET_ELEMENT);
  title = '';
  subtitle = '';
  content = '';
  src: string;
  buttonText: string;
  link = new TbLink();
  blendMode: BlendMode;

  constructor(src?: string) {
    this.src = src;
  }

  static normalizeInPlace(element: SlideshowElement): SlideshowElement {
    const pureElement = new SlideshowElement();

    element.title = element.title ?? pureElement.title;
    element.subtitle = element.subtitle ?? pureElement.subtitle;
    element.content = element.content ?? pureElement.content;
    element.src = element.src ?? pureElement.src;
    element.buttonText = element.buttonText ?? pureElement.buttonText;
    element.link = TbLink.normalizeInPlace(element.link ?? pureElement.link);
    element.blendMode = element.blendMode ?? pureElement.blendMode;

    return element;
  }
}
